import React from 'react';
import Home from './pages/Home/Home';
import Layout from './layout/Layout';
import './styles/app.scss';

const App = () => (
  <Layout>
    <Home />
  </Layout>
);

export default App;
